import { DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutResponsibilitySalesActivityReport } from './autogen/AutogenLayoutResponsibilitySalesActivityReport';

/**
 * Sales Activity Responsibility Report
 * PBI: 352251
 *
 * Extends Sales Activity Report with responsibility hierarchy filtering.
 * Includes dynamic page break behavior based on Group By selection.
 */
export class ResponsibilitySalesActivityReport extends AutogenLayoutResponsibilitySalesActivityReport {

    onLoad() {
        // Set default values
        this.textboxCustomerProspectType.setSelectedItemFromValue("A");
        this.textboxGroupBy.setSelectedItemFromValue("B");
        this.checkboxIncludeRemarks.checked = false;
        this.textboxSortBy.setSelectedItemFromValue("A");
        this.textboxActivityType.setSelectedItemFromValue("A");

         // Set up dynamic customer lookup based on customer/prospect type selection
        this.textboxCustomerProspectTypeOnChange();
    }

    /**
     * Filters hierarchy codes based on selected hierarchy level.
     */
    private textboxHierarchyCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.hierarchy_level = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }

    /**
     * Handles hierarchy level changes.
     * Enables/disables hierarchy code field based on whether a level is selected.
     */
    private textboxHierarchyLevelOnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxHierarchyCode.clear();
        this.textboxHierarchyCode.enabled = event.hasSelection();
    }

    /**
     * Update the customer lookup model based on the selected customer/prospect type
     */
    textboxCustomerProspectTypeOnChange(): void {
        const typeValue = this.textboxCustomerProspectType.selectedItem?.value;

        // Get the textbox component from the excludable textbox
        const customerTextbox = this.excludabletextboxCustomerId.textbox;

        if (!customerTextbox) {
            return;
        }

        customerTextbox.clear();
        // Update lookup model based on selection
        // A = Both (PROSP_CUST), B = Prospects Only (PROSPECT), C = Customers Only (CUST_ALL)
        switch (typeValue) {
            default:
            case "A": // Both
                customerTextbox.caption = "Customer(s) / Prospect(s)";
                break;
            case "B": // Prospects Only
                customerTextbox.caption = "Prospect(s)";
                break;
            case "C": // Customers Only
                customerTextbox.caption = "Customer(s)";
                break;
        }
    }

    excludabletextboxOperationsUserBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        // Filter to only show User ('U') or Employee ('E') web user types
        event.filter.web_user_type = "U || E";
    }

    textboxGroupByOnChange(): void {
        const groupByValue = this.textboxGroupBy.selectedItem?.displayValue;

        if (groupByValue && groupByValue !== "None") {
            this.checkboxPageBreak.enabled = true;
        } else {
            this.checkboxPageBreak.checked = false;
            this.checkboxPageBreak.enabled = false;
        }
    }

    textboxCustomersBeforeLookupModelSearch(event) {
        const customersOrProspects = this.textboxCustomerProspectType.selectedItem?.value;
        switch (customersOrProspects) {
            default:
            case "A": // Both
                // No filtering
                break;
            case "B": // Prospects Only
                event.filter.type_of = "P"; // Filter to prospects only
                break;
            case "C": // Customers Only
                event.filter.type_of = "C"; // Filter to customers only
        }
    }

    /** This is an event handler for the beforeExecution event of sourceResponsibilityPendingActivitiesReport. */
    sourceResponsibilityPendingActivitiesReportBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.hierarchy_level_number = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }

    textboxMarketingActivitiesBeforeLookupModelSearch(event) {
        event.filter.type_of = "C"; // customers. See RowAbstractMarketActivity.TYPE_OF_CUSTOMER/CARRIER
    }
}
